export enum paginationStatuses {
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    CANCELLED = 'CANCELLED',
    ERROR = 'ERROR',
}
